export class Tail {
	id: number;
	tail: string;
}
